import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import AppContext from "../../../contexts/AppContext";
import { subscribe } from "../../../services/common";

export class SubscriberForm extends Component {
    constructor(props) {
        super(props);        
    }
    state = {
        item: {
            email: null
        },
        errors: {}
    };

    onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    };
    handleValidation(){
        let fields = this.state.item;
        let err_msg = '';
        let formIsValid = true;       

        if(!fields.email){
            formIsValid = false;
            err_msg = "Please enter email address.";
        }

        if(fields.email && !this.isValidEmailAddress(fields.email))
        {
            formIsValid = false;
            err_msg = "Please enter valid email address.";
        }        
        if(!formIsValid)
        {            
            this.context.state.showCodeMessage(err_msg,'error');
        }
        
        return formIsValid;
    } 
    isValidEmailAddress = address => {
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i)
        return !! pattern.test(address);
    }
    
    submitSubscribe = e => {
        e.preventDefault();
        if(this.handleValidation())
        {   
            
            subscribe(this.state.item)
                .then(res => {
                    localStorage.setItem("subscriber_email", this.state.item.email);                                    
                    //this.props.history.push(`/process/checkout`);
                    if (localStorage.getItem("user_steps") == 'writing-jobs') {
                        this.props.history.push("/process/writingjobs");
                    } else if (localStorage.getItem("user_steps") == 'billing') {
                        this.props.history.push("/process/step3");
                    } else if (localStorage.getItem("user_steps") == 'select-plan') {
                        this.props.history.push("/process/select-plan");
                    } 
                    else if (localStorage.getItem("user_steps") == 'account') {
                        this.props.history.push("/account");
                    } else {
                        this.props.history.push("/register");
                    }
                })
                .catch(errors => {
                    this.context.state.handelError(errors);
                });                          
        }
    };
	render() {
        return (            
            <form className="form-inline" onSubmit={this.submitSubscribe}>                
                <div className="form-group mr-3 mb-2">
                    <label htmlFor="email" className="sr-only">Password</label>
                    <input type="text" onChange={this.onChange} className="form-control" name="email" id="email" ref="email" placeholder="youremail@example.com" autoComplete="off"/>                    
                </div>                
                <button type="submit" className="btn btn-primary mb-2">Get Writing Gigs</button>
            </form>
		);        
    }
}

SubscriberForm.contextType = AppContext;
export default withRouter(SubscriberForm);



// WEBPACK FOOTER //
// ./src/components/general/include/SubscriberForm.js